<template>
    <v-container>
        <StaticInvoiceViewer v-if="screen_data.invoice" :rectified_inv="rectificative_invoice"
                :invoice="screen_data.invoice" :configuration="screen_data.configuration" :key="screen_data.invoice.toString()">
        </StaticInvoiceViewer>
    </v-container>
</template>

<script>
import StaticInvoiceViewer from "../components/StaticInvoiceViewer.vue";
import {VueInvoiceEditorScreenData} from '../modules/facturae/infra/VueInvoiceEditorScreenData';
import { ApiInvoiceableRepository } from '../modules/facturae/infra/ApiInvoiceableRepository';
import { ApiConfigurationRepository } from "@/modules/facturae/infra/ApiConfigurationRepository";
export default {
    components: {
        StaticInvoiceViewer,
    },
    props: {
        invoiceable_id:{
            type: [Number,String],
            required: false,
            default: null
        },
        companydb_id:{
            type: [Number,String],
            required: false,
            default: null
        },
        invoiceable_type: {
            type: String,
            required: false,
            default: 'invoice'
        }
    },
    data() {
        const screen_data = new VueInvoiceEditorScreenData();
        return {
            screen_data:screen_data,
            rectificative_invoice: null
        }
    },
    async mounted() {
        let invoiceable_repo = new ApiInvoiceableRepository()
        let inv = null
        if (this.invoiceable_id){
            inv = await invoiceable_repo.find_by_id(this.invoiceable_id)
            if (inv && inv.rectificative && inv.rectificative_info && inv.rectificative_info.invoice_id) {
                this.rectificative_invoice = await invoiceable_repo.find_by_id(inv.rectificative_info.invoice_id)
            }
            if(!inv){
                let router_name = this.invoiceable_type == 'budget' ? 'budget-list' : this.invoiceable_type == 'delivery_note' ? 'delivery-note-list' : 'invoice-list'
                this.$router.push({ name: router_name, params: { 'companydb_id': this.companydb_id } });
                return
            }
        }
        let config_repo = new ApiConfigurationRepository()
        this.screen_data.configuration = await config_repo.get_configuration(this.companydb_id, inv.type)
        this.screen_data.setInvoice(inv)
    },
    methods: {
        
    },
    computed:{
        
    },

}
</script>

<style>
</style>